import React from 'react';
import { number } from '../../../Common/Util/number';
import { useRegistersChartsDataContext } from './hooks/useRegistersChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const TableMonthlyEvolutionRegisters = () => {
    const { chartData } = useRegistersChartsDataContext();

    const columns = [
        {
            key: 'description',
            header: 'Mês/Ano',
            headerStyle: { 
                width: '25%',
                fontWeight: '500'  
            },
            cellStyle: {
            }
        },
        {
            key: 'novos_cadastros',
            header: 'Novos',
            headerStyle: { 
                width: '25%', 
                textAlign: 'right',
                fontWeight: '500'  
            },
            cellStyle: { 
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'atualizacoes',
            header: 'Atualizações',
            headerStyle: { 
                width: '25%', 
                textAlign: 'right',
                fontWeight: '500'  
            },
            cellStyle: { 
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'recusas',
            header: 'Recusa',
            headerStyle: { 
                width: '25%', 
                textAlign: 'right',
                fontWeight: '500' 
            },
            cellStyle: { 
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const calculateTotals = (data) => {
        if (!data || !Array.isArray(data)) return null;
        
        return {
            description: 'Total',
            novos_cadastros: data.reduce((acc, curr) => acc + Number(curr.novos_cadastros || 0), 0),
            atualizacoes: data.reduce((acc, curr) => acc + Number(curr.atualizacoes || 0), 0),
            recusas: data.reduce((acc, curr) => acc + Number(curr.recusas || 0), 0)
        };
    };

    const tableData = React.useMemo(() => {
        if (!chartData?.monthlyEvolutionRegisters) return [];
        
        const data = [...chartData.monthlyEvolutionRegisters];
        const totals = calculateTotals(chartData.monthlyEvolutionRegisters);
        
        if (totals) {
            data.push(totals);
        }
        
        return data;
    }, [chartData?.monthlyEvolutionRegisters]);


    return (
        <div className="chart-container-dashboards">
            <TableComponent
                data={tableData}
                columns={columns}
                title="Totais"
                showTotal={false} 
                maxHeight="400px" 
                className="w-100" 
                isLastTotal={true}
            />
        </div>
    );
};

